(() => {
  const ready = (callback) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', callback, { once: true })
    : callback();

  ready(() => {
    const header = document.querySelector('[data-stc-header]');
    const menu = document.querySelector('[data-stc-menu]');
    const toggle = document.querySelector('[data-stc-menu-toggle]');
    const desktopMenus = header ? [...header.querySelectorAll('[data-stc-nav-item]')] : [];
    const closeDesktopMenus = (except = null) => desktopMenus.forEach((details) => {
      if (details !== except) details.open = false;
    });
    if (header && menu && toggle) {
      toggle.addEventListener('click', () => {
        const open = !menu.classList.contains('is-open');
        menu.classList.toggle('is-open', open);
        toggle.setAttribute('aria-expanded', String(open));
        toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
      desktopMenus.forEach((details) => details.addEventListener('toggle', () => {
        if (details.open && window.innerWidth >= 990) closeDesktopMenus(details);
      }));
      header.querySelectorAll('[data-stc-menu-group-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const group = button.closest('[data-stc-menu-group]');
          const open = !group.classList.contains('is-open');
          group.classList.toggle('is-open', open);
          button.setAttribute('aria-expanded', String(open));
        });
      });
      document.addEventListener('pointerdown', (event) => {
        if (window.innerWidth >= 990 && !header.contains(event.target)) closeDesktopMenus();
      });
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') closeDesktopMenus();
      });
      window.addEventListener('pagehide', () => closeDesktopMenus());
      window.addEventListener('pageshow', () => closeDesktopMenus());
      window.addEventListener('resize', () => {
        closeDesktopMenus();
        if (window.innerWidth >= 990) {
          menu.classList.remove('is-open');
          toggle.setAttribute('aria-expanded', 'false');
        }
      });
    }

    const hero = document.querySelector('[data-stc-hero]');
    if (hero) {
      const slides = [...hero.querySelectorAll('[data-stc-slide]')];
      const count = hero.querySelector('[data-stc-hero-count]');
      let index = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let timer;
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === index;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        if (count) count.textContent = `${index + 1} / ${slides.length}`;
      };
      const schedule = () => {
        clearInterval(timer);
        if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(() => show(index + 1), 6500);
      };
      hero.querySelector('[data-stc-hero-previous]')?.addEventListener('click', () => { show(index - 1); schedule(); });
      hero.querySelector('[data-stc-hero-next]')?.addEventListener('click', () => { show(index + 1); schedule(); });
      show(index);
      schedule();
    }

    if (!/^\/products\//i.test(window.location.pathname)) return;
    const productHandle = decodeURIComponent(window.location.pathname.match(/^\/products\/([^/?#]+)/i)?.[1] || '');
    if (!productHandle) return;
    let productRequest;
    const productData = () => {
      if (!productRequest) {
        const root = window.Shopify?.routes?.root || '/';
        productRequest = fetch(`${root}products/${encodeURIComponent(productHandle)}.js`, {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
        }).then((response) => response.ok ? response.json() : null).catch(() => null);
      }
      return productRequest;
    };
    const imageUrl = (value) => {
      if (!value) return '';
      if (typeof value === 'string') return value;
      return value.src || value.url || value.preview_image?.src || value.preview_image?.url || '';
    };
    const imageKey = (value) => {
      const raw = imageUrl(value);
      if (!raw) return '';
      try {
        const url = new URL(raw, window.location.origin);
        return decodeURIComponent(url.pathname).replace(/_[0-9]+x[0-9]*?(?=\.[a-z]+$)/i, '').toLowerCase();
      } catch (_error) {
        return raw.split(/[?#]/)[0].toLowerCase();
      }
    };
    const selectedVariant = (product, changed) => {
      if (!product?.variants?.length) return null;
      const form = changed?.closest?.('form');
      const idInputs = [form?.querySelector('[name="id"]'), document.querySelector('form[action*="/cart/add"] [name="id"]')].filter(Boolean);
      for (const input of idInputs) {
        const match = product.variants.find((variant) => String(variant.id) === String(input.value));
        if (match) return match;
      }
      const queryId = new URL(window.location.href).searchParams.get('variant');
      return product.variants.find((variant) => String(variant.id) === String(queryId)) || null;
    };
    const semanticVariantImage = (product, variant) => {
      const native = imageUrl(variant?.featured_media) || imageUrl(variant?.featured_image);
      if (native) return native;
      const images = (product?.images || []).map(imageUrl).filter(Boolean);
      const sku = String(variant?.sku || variant?.title || '').toLowerCase();
      if (!sku || !images.length) return '';
      const exact = images.find((image) => imageKey(image).includes(sku));
      if (exact) return exact;
      if (/^[a-z]{2,8}c/i.test(sku)) return images.find((image) => /(?:conventional|casting)/i.test(imageKey(image))) || '';
      if (/^[a-z]{2,8}s/i.test(sku)) return images.find((image) => /spinning/i.test(imageKey(image))) || '';
      return '';
    };
    const activeProductImage = () => {
      for (const selector of [
        'main media-gallery [data-media-id].is-active img',
        'main [data-product-media].is-active img',
        'main .product__media-item.is-active img',
        'main .product-gallery__media.is-active img',
      ]) {
        const image = document.querySelector(selector);
        if (image) return image;
      }
      return [...document.querySelectorAll('main img')].find((image) => {
        const bounds = image.getBoundingClientRect();
        const style = window.getComputedStyle(image);
        return bounds.width >= 180 && bounds.height >= 180 && style.display !== 'none' && style.visibility !== 'hidden';
      }) || null;
    };
    const activateVariantMedia = async (changed) => {
      const product = await productData();
      const variant = selectedVariant(product, changed);
      const target = semanticVariantImage(product, variant);
      const targetKey = imageKey(target);
      if (!targetKey) return;
      const active = activeProductImage();
      if (active && imageKey(active.currentSrc || active.src) === targetKey) return;
      const matchingImage = [...document.querySelectorAll('main img')].find((image) => imageKey(image.currentSrc || image.src) === targetKey);
      const mediaItem = matchingImage?.closest('[data-media-id]');
      const mediaId = mediaItem?.getAttribute('data-media-id');
      const gallery = mediaItem?.closest('media-gallery') || document.querySelector('main media-gallery');
      if (gallery && mediaId && typeof gallery.setActiveMedia === 'function') gallery.setActiveMedia(mediaId, true);
      else matchingImage?.closest('button, a, [role="button"]')?.click();
      window.setTimeout(() => {
        const current = activeProductImage();
        if (!current || imageKey(current.currentSrc || current.src) === targetKey) return;
        current.closest('picture')?.querySelectorAll('source').forEach((source) => source.removeAttribute('srcset'));
        current.removeAttribute('srcset');
        current.removeAttribute('sizes');
        current.src = target;
        current.alt = String(variant?.public_title || variant?.title || current.alt || '');
      }, 180);
    };
    const scheduleVariantMedia = (changed) => {
      window.setTimeout(() => activateVariantMedia(changed), 80);
      window.setTimeout(() => activateVariantMedia(changed), 420);
      window.setTimeout(() => activateVariantMedia(changed), 900);
    };
    document.addEventListener('change', (event) => {
      if (event.target?.matches?.('main input[type="radio"], main select, main input[name="id"]')) scheduleVariantMedia(event.target);
    }, true);
    document.addEventListener('click', (event) => {
      const target = event.target?.closest?.('main label, main button, main [role="radio"], main [data-option-value]');
      if (target) scheduleVariantMedia(target);
    }, true);
    scheduleVariantMedia(document.querySelector('main input[type="radio"]:checked, main select'));
  });
})();
